/* eslint-disable max-len */
import React from 'react';

const FacebookIcon = () => (
  <svg className="facebook-icon" viewBox="0 0 489.68 486.7">
    <path d="M495,251.8C495,116.58,385.38,7,250.16,7S5.32,116.58,5.32,251.8C5.32,374,94.86,475.3,211.91,493.67V322.58H149.74V251.8h62.17V197.86c0-61.36,36.55-95.26,92.47-95.26,26.79,0,54.81,4.79,54.81,4.79v60.25H328.32c-30.42,0-39.9,18.87-39.9,38.23V251.8h67.9l-10.85,70.78H288.42V493.67C405.47,475.3,495,374,495,251.8Z" transform="translate(-5.32 -6.96)"/>
  </svg>
);

export default FacebookIcon;
